<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        initDone: false
      }
    },
    beforeUpdate () {
      if (!this.initDone) {
        this.init()
      }
    },
    methods: {
      init () {
        this.$store.dispatch('marketing/processSpecificQueryParams', {}, { global: true })
        this.initDone = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue